import TopicPageTemplate from '@templates/topic-page/detail';

// ---------------------------------------------------------

import FlexibleData from '@lib/cms/flexibleData';

// ---------------------------------------------------------

export async function getStaticProps(context) {
  const preview = context.preview || false;
  const previewEnv = context?.previewData?.environment ?? null;
  const data = await FlexibleData.fetchTopicPage(
    'Relocation',
    'relocation-index',
    preview,
    previewEnv
  );

  return {
    props: { data, preview }
  };
}

// ---------------------------------------------------------

const Home = ({ data, preview }) => {
  return (
    <TopicPageTemplate
      collection="Relocation"
      coreService
      pageData={data}
      preview={preview}
    ></TopicPageTemplate>
  );
};

export default Home;
